import officeApi from 'services/api/officeApi'
import EmployeeApi from 'services/api/EmployeeApi';

/* Service class used to perform api calls for showing offices */
class OfficesService {

    constructor() {
        this.api = officeApi.create();
        this.employeeApi = EmployeeApi.create();
    }

    /**
     * Retrieves the summary office data for the specified office
     */
    async getOfficeSummary(officeId) {
        let employees = null
        try {
            let response = await this.api.getOfficeSummary(officeId);
            if (response) {
                if (response.status === 200) {
                    employees = response.data
                } else if (response.status === 403 || response.status === 400 || response.status === 404) {
                    return { error_code: response.status }
                }
            }
        } catch (ex) {
            console.log(ex)
        }

        return employees
    }

    async getEmployees(officeId, offset, sortType, reversed) {
        let summary = null
        try {
            let response = await this.employeeApi.getEmployees(officeId, offset, sortType, reversed);
            if (response) {
                if (response.status === 200) {
                    summary = response.data
                } else if (response.status === 403 || response.status === 400 || response.status === 404) {
                    return { error_code: response.status }
                }
            }
        } catch (ex) {
            console.log(ex)
        }

        return summary
    }
}

const officesService = new OfficesService();
export default officesService;